<template>
    <div class="score-cards">
        <div class="score-card">
            <div class="score-title">Storytelling</div>
            <div class="score-container">
                <div class="score-value">85</div>
                <div class="score-max">/100</div>
            </div>
            <div class="progress-bar">
                <div class="progress" style="width: 85%;"></div>
            </div>
            <div class="score-description">
                La tua capacità di raccontare storie coinvolgenti e memorabili che risuonano con il tuo pubblico.
            </div>
        </div>
        <div class="score-card">
            <div class="score-title">Community</div>
            <div class="score-container">
                <div class="score-value">92</div>
                <div class="score-max">/100</div>
            </div>
            <div class="progress-bar">
                <div class="progress" style="width: 92%;"></div>
            </div>
            <div class="score-description">
                L'engagement e la fidelizzazione della tua community attraverso contenuti e interazioni di valore.
            </div>
        </div>
        <div class="score-card">
            <div class="score-title">Experience</div>
            <div class="score-container">
                <div class="score-value">78</div>
                <div class="score-max">/100</div>
            </div>
            <div class="progress-bar">
                <div class="progress" style="width: 78%;"></div>
            </div>
            <div class="score-description">
                La qualità dell'esperienza che offri ai tuoi utenti attraverso ogni touchpoint del brand.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScoreCards'
}
</script>

<style lang="scss" scoped>
.score-cards {
    display: flex;
    gap: 2.5rem;
    margin-top: 3rem;
    justify-content: center;
    width: 100%;
}

.score-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 0;
    padding: 2rem;
    width: 280px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background: #2e4eed;
        opacity: 0.8;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 12px 32px rgba(46, 78, 237, 0.15);
    }

    .score-title {
        font-size: 1.25rem;
        font-weight: 700;
        color: #1a1a1a;
        display: flex;
        align-items: center;
        gap: 0.75rem;

        &::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #2e4eed;
            border-radius: 0;
        }
    }

    .score-container {
        display: flex;
        align-items: baseline;
        gap: 0.5rem;
    }

    .score-value {
        font-size: 3rem;
        font-weight: 800;
        color: #2e4eed;
        line-height: 1;
    }

    .score-max {
        font-size: 1.25rem;
        font-weight: 500;
        color: #666;
    }

    .progress-bar {
        width: 100%;
        height: 10px;
        background: rgba(46, 78, 237, 0.08);
        border-radius: 0;
        overflow: hidden;
        margin-top: 0.5rem;

        .progress {
            height: 100%;
            background: linear-gradient(90deg, #2e4eed, #56BCEE);
            border-radius: 0;
            transition: width 1.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
    }

    .score-description {
        font-size: 0.9375rem;
        color: #666;
        line-height: 1.5;
        margin-top: 0.5rem;
    }
}

@media (max-width: 768px) {
    .score-cards {
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
    }

    .score-card {
        width: 100%;
        max-width: 320px;
        padding: 1.5rem;
    }
}
</style>